import { ModuleFE_FindingView } from './_entity/finding-view/index.js';
import { RoutePermissions } from '@nu-art/permissions-frontend';
import { Page_AdvisorUI } from './ui/Page_AdvisorUI/Page_AdvisorUI.js';
import { ModuleFE_FAQ } from './_entity/frequently-asked-question/ModuleFE_FAQ.js';
import { ModuleFE_Tag, ModuleFE_Variable } from '@app/hcs-frontend';
import { ModuleFE_Action } from '@app/pathway-frontend';
import { permissions_AdvisorUIManager } from './permissions/advisor-ui-manager.js';
export const UrlParam_EhrId = 'ehr-id';
export const UrlParam_UserType = 'user-type';
export const avatarMode = 'avatar-mode';
const EditorKey_AdvisorUI = 'advisor-ui-editor';
export const Route_AdvisorUIEditor = {
    key: EditorKey_AdvisorUI,
    path: 'advisor-ui',
    enabled: RoutePermissions(permissions_AdvisorUIManager.Release),
    Component: Page_AdvisorUI,
    modulesToAwait: [ModuleFE_FindingView, ModuleFE_FAQ, ModuleFE_Variable, ModuleFE_Tag, ModuleFE_Action],
};
//# sourceMappingURL=consts.js.map